import { GzzChild } from "../general/GzzChild";
import { SrvDeceased } from "./SrvDeceased";
import { UploadEntity } from "moh-package";

export class SrvClaim {

  DeceasedDetails: SrvDeceased;
  Children: GzzChild[];
  RadiationStartDate: Date;
  RadiationEndDate: Date;
  TreatedBy: string;
  TreatedByAddress: string;
  DiagnosedBy: string;
  DiagnosedDate: Date;
  HadDiedFromTheDecease: boolean;
  ProvingDocuments: UploadEntity[];
  WasClaimSubmitted: boolean;
  SubmittedAt: number;
  CaseNumber: string;
  RullingTheCaseDate: Date;
  RullingTheCaseBy: string;

  constructor(data: SrvClaim) {

    Object.assign(this, data);

    if (data) {

      if (data.DeceasedDetails) {
        this.DeceasedDetails = new SrvDeceased(data.DeceasedDetails);
      }

      if (data.Children) {
        for (var i = 0; i < data.Children.length; i++) {
          this.Children[i] = new GzzChild(data.Children[i]);
        }
      }

      if (data.SubmittedAt) {
        this.SubmittedAt = data.SubmittedAt['Code'];
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/models/Survivors/SrvClaim.ts